import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import isEnhanceFormFieldAccessibility from '@/utils/formFieldAccessibility'

const FORM_ACCESSIBILITY_STYLE_VARS = {
	'--form-text-color': '--form-text-color-accessibility',
	'--form-label-color': '--form-label-color-accessibility',
	'--form-border-color': '--form-border-color-accessibility',
	'--error-color': '--error-color-accessibility',
	'--form-error-bg-color': '--form-error-bg-color-accessibility',
}

const useFormAccessibilityStyles = () => {
	const settings = useSelector((state) => state.settings)

	useEffect(() => {
		const root = document.documentElement

		if (isEnhanceFormFieldAccessibility(settings)) {
			Object.entries(FORM_ACCESSIBILITY_STYLE_VARS).forEach(([name, value]) => {
				root.style.setProperty(name, `var(${value})`)
			})
		} else {
			Object.keys(FORM_ACCESSIBILITY_STYLE_VARS).forEach((name) => {
				root.style.removeProperty(name)
			})
		}

		return () => {
			Object.keys(FORM_ACCESSIBILITY_STYLE_VARS).forEach((name) => {
				root.style.removeProperty(name)
			})
		}
	}, [settings])
}

export default useFormAccessibilityStyles
